// extracted by mini-css-extract-plugin
module.exports = {"card":"_Card_card__1Hak5"};